module.exports = __webpack_public_path__ + "static/media/miasto_blocked.69d5340b.svg";